const variants = {
  PRIMARY: 'primary',
  LINK: 'link',
};

export default variants;
